export const isObject = (obj) => {
  if (typeof obj === 'object' && !Array.isArray(obj) && obj !== null) {
    return true
  }
  return false
}

/**
 * sanitizeProps from frontend friends is too strict (It'll throw errors on a ny blacklisted props). This will just filter those out
 * @param {Array} blackList and array of keys to filter out
 */
export const softSanitizeProps = (props, blackList) => {
  const sanitizedProps = Object.fromEntries(Object.entries(props).filter(([key]) => !blackList.includes(key)))
  return sanitizedProps
}

export const chunkArray = (array, limit) => {
  const chunks = []
  const arr = [...array]
  while (arr.length > 0) {
    chunks.push(arr.splice(0, limit))
  }
  return chunks
}

export const isDeepEqual = (x, y) => {
  if (x === y) {
    return true
  }

  if (typeof x !== 'object' || typeof y !== 'object' || x === null || y === null) {
    return false
  }

  const keysX = Object.keys(x)
  const keysY = Object.keys(y)

  if (keysX.length !== keysY.length) {
    return false
  }

  return !keysX.some((key) => !isDeepEqual(x[key], y[key]))
}

export const removeDuplicatesByKey = (arr, key) => {
  const safeArr = arr.filter(Boolean)
  const uniqueItems = []
  const keys = new Set()

  safeArr.forEach((item) => {
    const itemKey = item[key]

    if (!keys.has(itemKey)) {
      keys.add(itemKey)
      uniqueItems.push(item)
    }
  })

  return uniqueItems
}

export const getDuplicatesAcrossArrays = (...arrays) => {
  if (!arrays.every((arr) => Array.isArray(arr))) {
    throw new Error('All inputs must be arrays')
  }
  if (arrays.length < 2) {
    return []
  }

  const values = new Map()
  const duplicates = new Set()
  arrays.forEach((array) => {
    array.forEach((item) => {
      if (values.has(item)) {
        duplicates.add(item)
      } else {
        values.set(item, true)
      }
    })
  })
  return Array.from(duplicates)
}
